import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface IconCheckProps {
  type: string;
  name: string;
  onChange?: (e: any) => void;
  value: number;
  display: { name: string; price: number };
  selected?: number;
  refs?: any;
  noCheck?: boolean;
}

const IconCheck: React.FC<IconCheckProps> = ({
  display,
  value,
  selected,
  refs,
  noCheck,
  ...inputProps
}: IconCheckProps) => {
  let owlClass = "a-select-icon";
  return (
    <label className={joinClassnames(`${owlClass}`)}>
      <input
        {...inputProps}
        value={value}
        checked={value === selected}
        onChange={inputProps.onChange}
        readOnly
        ref={refs}
      />
      <span>{display.name}</span>
      <span>{display.price}</span>
      {!noCheck ? (
        <div className={`${owlClass}_icon`}>
          <span></span>
        </div>
      ) : null}
      <div className="a-select-icon_bg-ckecked"></div>
    </label>
  );
};

IconCheck.defaultProps = {};

export default IconCheck;
